import { LocaleData, LocaleConfig } from '../types';

export const config: LocaleConfig = {
    id: 'ja',
    fullName: 'Japanese',
    nativeName: '日本語',
    direction: 'ltr'
};

const translations: LocaleData = {
    title: "ArgVoid",
    landing_title: "何かすごいことがやってくる",
    landing_subtitle: "ArgVoid はアプリおよびゲームの開発スタジオです。新しいものがすぐに登場しますので、お楽しみに！",
    select_language: "言語の選択",
    search_placeholder: "言語を検索...",
    terms_title: "利用規約",
    policy_title: "プライバシーポリシー",
    cookies_title: "クッキーポリシー",
    terms_content: `
        <strong>1。規約への同意</strong><br>
        ArgVoid にアクセスすると、これらの利用規約に同意したことになります。これらの規約に同意しない場合は、サービスを使用しないでください。<br><br>

        <strong>2。プラットフォームの使用状況</strong><br>
        ArgVoid とそのアプリケーションは、情報提供および創造的な目的で「現状のまま」提供されます。サービスは合法的な目的にのみ使用する必要があります。<br><br>

        <strong>3。禁止行為</strong><br>
        サイトの脆弱性の悪用、スパム送信、またはインフラストラクチャへの不正アクセスの試みは固く禁止されています。<br><br>

        <strong>4。免責事項</strong><br>
        プラットフォームおよびサービスは、予告なくいつでも変更される場合があります。サービスの稼働時間や可用性については保証されません。
    `,
    policy_content: `
        <strong>1。情報収集</strong><br>
        現時点では、このプラットフォームではユーザー認証やアカウントの作成は必要ありません。個人を特定できる情報 (名前や電子メール アドレスなど) が訪問者から積極的に収集されることはありません。<br><br>

        <strong>2。使用状況データ</strong><br>
        サイトのトラフィックを理解し、アプリケーションを改善するために、基本的な匿名化された分析が収集される場合があります。このデータは個々のユーザー ID にはリンクされていません。<br><br>

        <strong>3。サードパーティサービス</strong><br>
        ホスティングおよび分析サービスにはサードパーティのプロバイダーが利用される場合があります。これらの各プロバイダーのプライバシー慣行は、インフラストラクチャ上で処理される匿名データを管理します。<br><br>

        <strong>4。データセキュリティ</strong><br>
        プラットフォームを保護するために、合理的なセキュリティ対策が実装されています。ただし、インターネット上で完全に安全な送信方法はありません。<br><br>
    `,
    cookies_content: `
        <strong>1。 Cookie とローカル ストレージとは何ですか?</strong><br>
        Cookie とブラウザのローカル ストレージは、訪問後も構成設定を記憶するためにデバイスに保存される小さなデータ ファイルです。<br><br>

        <strong>2。使用目的</strong><br>
        ブラウザの LocalStorage は、次のような構成設定を保存するためにのみ使用されます。<br>
        - 言語設定<br>
        - ユーザー インターフェイスの設定 (レイアウトやテーマの設定など)<br>
        - アプリケーションの一時キャッシュ<br><br>

        <strong>3。追跡なし</strong><br>
        Cookie とローカル ストレージは、広告やサードパーティの追跡目的には使用されません。保存されたすべてのデータは、プラットフォームのコア機能専用です。<br><br>

        <strong>4。コントロール</strong><br>
        ブラウザのデータは、ブラウザの設定を通じていつでもクリアでき、ローカル設定がリセットされます。
    `,
    cookie_consent_text: "当社は、セッションをアクティブに維持したり、言語設定やその他のカスタム設定を保存したりするなど、Web サイトが正しく機能することを保証するために基本的な Cookie を使用します。",
    read_policy: "クッキーポリシーを読む",
    support_title: "サポートに連絡する",
    support_subject_label: "主題",
    support_message_label: "メッセージ",
    support_submit_button: "メッセージを送信する",
    support_hint: "注: これにより、メッセージを送信するためのデフォルトの電子メール アプリケーションが開きます。",
    support_success_msg: "メールアプリを開いて...",
    support_error_msg: "メッセージの送信に失敗しました。後でもう一度試してください。",
    explorer_title: "エクスプローラ",
    history_title: "歴史",
    animation_title: "アニメーション",
    config_title: "構成",
    tool_mouse: "選択 (Ctrl+M)",
    tool_brush: "ブラシ (Ctrl+B)",
    tool_brush_mode: "トグルモード (点灯/透明)",
    tool_eraser: "消しゴム (Ctrl+E)",
    tool_brush_size: "ブラシサイズを調整する",
    tool_bucket: "塗りつぶし (Ctrl+F)",
    tool_eyedropper: "スポイト",
    tool_grid: "グリッド (Ctrl+Shift+B)",
    tool_rotate: "回転 (Ctrl+Shift+R)",
    tool_flip_h: "左右反転 (Ctrl+Shift+H)",
    tool_flip_v: "V を反転 (Ctrl+Shift+V)",
    tool_transpose: "転置 (Ctrl+Shift+T)",
    label_width: "幅",
    label_height: "身長",
    label_frames: "フレーム数",
    label_animation: "アニメーションスタイル",
    label_background_color: "背景色",
    label_interval: "間隔",
    tool_anim_config: "アニメーション構成",
    label_new_width: "新しい幅",
    label_new_height: "新しい高さ",
    label_apply: "適用する",
    label_colors: "色",
    label_size: "サイズ",
    label_tolerance: "許容範囲",
    val_horizontal: "水平",
    val_vertical: "垂直",
    val_sequence: "順序",
    val_bounce: "バウンス",
    val_random: "ランダム",
    val_solid: "固体",
    val_clear: "クリア",
    action_add_sheet: "新しいシート",
    action_import: "輸入",
    action_export: "輸出",
    action_sort_projects: "選別",
    sort_date_old: "古い順",
    sort_date_new: "新しい順",
    sort_name_az: "名前 (A ～ Z)",
    sort_name_za: "名前 (Z-A)",
    action_new_sprite: "新しいスプライト",
    action_new_project: "新しいプロジェクト",
    modal_save_all_title: "すべての変更を保存",
    modal_save_all_desc: "保存するアセットを選択します:",
    modal_save_selected: "選択したものを保存",
    action_saved: "保存されました",
    modal_create_sprite_title: "新しいスプライトの作成",
    modal_create_project_title: "新しいプロジェクトの作成",
    modal_add_sheet_title: "新しいシートを追加",
    modal_rename_sheet_title: "シートの名前を変更",
    modal_rename_sprite_title: "スプライトの名前を変更",
    modal_delete_sprite_title: "スプライトの削除",
    modal_delete_project_title: "プロジェクトの削除",
    modal_delete_sheet_title: "シートの削除",
    placeholder_sprite_name: "名前",
    placeholder_project_name: "名前",
    placeholder_sheet_name: "名前",
    placeholder_new_name: "新しい名前",
    action_create: "作成する",
    action_add: "追加",
    action_rename: "名前の変更",
    action_duplicate: "重複",
    action_delete: "消去",
    action_cancel: "キャンセル",
    confirm_delete_sprite: "このスプライトを削除してもよろしいですか?",
    confirm_delete_project: "このプロジェクトを削除してもよろしいですか?すべてのスプライトが削除されます。",
    confirm_delete_sheet: "このシートを削除してもよろしいですか?",
    err_select_sprite: "最初にスプライトを選択してください。",
    err_select_project: "最初にプロジェクトを選択してください。",
    err_name_empty: "名前を空にすることはできません。",
    err_sprite_exists: "その名前のスプライトはすでに存在します。",
    err_project_exists: "その名前のプロジェクトはすでに存在します。",
    err_no_content: "保存するコンテンツがありません。",
    err_no_changes: "保存する変更はありません。",
    err_delete_last_sheet: "最後のシートを削除できません。",
    err_extract_frames: "フレームを抽出できませんでした。",
    err_indexeddb: "ローカルに保存できませんでした。お使いのブラウザは IndexedDB をサポートしていない可能性があります。",
    msg_upload_success: "アップロードに成功しました: {0}",
    msg_upload_failed: "アップロードに失敗しました: {0}",
    msg_save_success: "保存に成功しました。",
    msg_saving: "保存中...",
    msg_multi_save_result: "{0} 個のアセットを保存しました。 {1} 個の失敗。",
    menu_title: "メニュー",
    menu_save: "保存",
    menu_save_all: "すべて保存",
    menu_support: "サポートに連絡する",
    label_local_storage: "ローカルストレージ",
    label_sign_in: "サインイン",
    modal_export_title: "スプライトのエクスポート",
    label_filename: "ファイル名",
    label_format: "形式",
    action_export_confirm: "輸出",
};

export default translations;
